<template>
  <component v-bind:is="currentComponent"></component>
</template>
<script>
import listaConsultas from "../components/consultas/Consultas.vue";
import novaConsulta from "../components/consultas/NovaConsulta.vue";
import perfilConsulta from "../components/consultas/PerfilConsulta.vue";

export default {
  components: {
    listaConsultas,
    novaConsulta,
    perfilConsulta,
  },
  data() {
    return {
      currentComponent: "",
    };
  },
  mounted() {
    this.currentComponent =
      this.$route.query.type === "a"
        ? "novaConsulta"
        : this.$route.query.type === "b"
        ? "perfilConsulta"
        : "listaConsultas";
  },
  watch: {
    $route(to, from) {
      this.currentComponent =
        to.query.type === "a"
          ? "novaConsulta"
          : to.query.type === "b"
          ? "perfilConsulta"
          : "listaConsultas";
    },
  },
};
</script>
<style scoped></style>
